/**
 * Wizard step counts for vehicle models.
 *
 * This file contains metadata about wizard flows that can be safely imported
 * by both server-side and client-side code without pulling in heavy dependencies.
 *
 * IMPORTANT: When adding/removing wizard steps, update these counts!
 * A test in apps/form/models/wizard-metadata.test.ts validates that these counts match the actual wizard step arrays.
 *
 * Related files:
 * - car-used: apps/form/models/car-used-wizard.ts
 * - a-tractor: apps/form/models/a-tractor-wizard.ts
 * - snowmobile: apps/form/models/snowmobile-wizard.ts
 * - car-leasing: apps/form/models/car-leasing-wizard.ts
 * - atv: apps/form/models/atv-wizard.ts
 * - moped: apps/form/models/moped-wizard.ts
 * - motorcycle: apps/form/models/motorcycle-wizard.ts
 * - agriculture-tractor: apps/form/models/agriculture-tractor-wizard.ts
 * - construction: apps/form/models/construction-wizard.ts
 * - mobile-home: apps/form/models/mobile-home-wizard.ts
 * - caravan: apps/form/models/caravan-wizard.ts
 */
export const WIZARD_STEP_COUNTS = {
    'car-used': 4,
    'a-tractor': 3,
    snowmobile: 3,
    'car-leasing': 4,
    atv: 3,
    moped: 3,
    motorcycle: 4,
    'agriculture-tractor': 2,
    construction: 3,
    'mobile-home': 3,
    caravan: 3,
};
